import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];
const IMG = "https://images.pexels.com/photos/4021779/pexels-photo-4021779.jpeg?auto=compress&cs=tinysrgb&w=1000";

export default function CtaCard({ onSignup }) {
    return (
        <section className="px-6 py-14" data-testid="cta-section">
            <motion.div
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-60px" }}
                transition={{ duration: 0.7, ease: EASE }}
                className="relative rounded-[2rem] overflow-hidden"
            >
                <img
                    src={IMG}
                    alt=""
                    loading="lazy"
                    className="absolute inset-0 w-full h-full object-cover"
                    aria-hidden="true"
                />
                <div className="absolute inset-0 bg-gradient-to-b from-teal-dark/95 to-teal/90" aria-hidden="true" />

                <div className="relative px-7 py-12 text-center">
                    <h2 className="font-extrabold tracking-tight leading-[1.12] text-[2rem] text-white">
                        Unlock a new level of medication management
                    </h2>
                    <p className="mt-4 text-white/85 text-[15px] leading-relaxed">
                        Turn complexity into clarity and worry into peace of mind.
                        Your well-being is our priority.
                    </p>
                    <button
                        onClick={onSignup}
                        className="mt-8 w-full h-14 rounded-full bg-teal text-white font-bold text-lg shadow-[0_12px_30px_-8px_rgba(0,0,0,0.35)] transition-all duration-200 hover:bg-[#12c5b1] active:scale-[0.98]"
                        data-testid="cta-join-button"
                    >
                        Join Med Check Alarm today
                    </button>
                    <p className="mt-5 text-white/80 text-sm">Start with a 7-day free trial</p>
                </div>
            </motion.div>
        </section>
    );
}
